import {
    AuthenticateResultModel,
    CheckoutResponse,
    Edition,
    EditionsDefinition,
    MarketingSource,
} from "../../api/proxies";
import { createAction, props } from "@ngrx/store";
import { AdditionalItem, AvailableAdditionalItemSection, AvailableProduct, Buyer, CreditCard } from "./model";

export const setMarketingSource = createAction("[Subscription] setMarketingSource", props<{ params: any }>());

export const saveBasicData = createAction(
    "[Subscription] saveBasicData",
    props<{ email: string; name: string; phone: string; creatorProfile: number; marketingSource: MarketingSource }>()
);

export const saveBasicDataComplete = createAction(
    "[Subscription] saveBasicDataComplete",
    props<{ email: string; name: string; phone: string; creatorProfile: number; marketingSource: MarketingSource }>()
);

export const saveBasicDataError = createAction("[Subscription] saveBasicDataError", props<{ error: any }>());

export const getEditions = createAction("[Subscription] getEditions", props<{ token: string | undefined }>());

export const getEditionsComplete = createAction(
    "[Subscription] getEditionsComplete",
    props<{ result: EditionsDefinition }>()
);

export const getEditionsByTokenError = createAction("[Subscription] getEditionsByTokenError");

export const getEditionsByTokenErrorRedirect = createAction("[Subscription] getEditionsByTokenErrorRedirect");

export const getEditionsError = createAction("[Subscription] getEditionsError", props<{ error: any }>());

export const loadAvailableAdditionalItems = createAction("[Subscription] loadAvailableAdditionalItems");

export const loadAvailableAdditionalItemsComplete = createAction(
    "[Subscription] loadAvailableAdditionalItemsComplete",
    props<{ sections: AvailableAdditionalItemSection[] }>()
);

export const loadAvailableAdditionalItemsError = createAction(
    "[Subscription] loadAvailableAdditionalItemsError",
    props<{ error: any }>()
);

export const loadAvailableAdditionalProducts = createAction("[Subscription] loadAvailableAdditionalProducts");

export const loadAvailableAdditionalProductsComplete = createAction(
    "[Subscription] loadAvailableAdditionalProductsComplete",
    props<{ products: AvailableProduct[] }>()
);

export const loadAvailableAdditionalProductsError = createAction(
    "[Subscription] loadAvailableAdditionalProductsError",
    props<{ error: any }>()
);

export const selectEdition = createAction(
    "[Subscription] selectEdition",
    props<{ edition: Edition; locked: boolean }>()
);

export const getEditionByToken = createAction(
    "[Subscription] getEditionByToken",
    props<{ token: string | undefined }>()
);

export const setCreditCard = createAction("[Subscription] setCreditCard", props<{ creditCard: CreditCard }>());

export const creditCardError = createAction("[Subscription] creditCardError", props<{ error: any }>());

export const checkout = createAction(
    "[Subscription] checkout",
    props<{
        editionName: string;
        hash: string;
        buyer: Buyer;
        billingCycle: number;
        numberOfInstallments: number;
        fiscalIdentifier: string;
        creditCard: CreditCard;
        address: any;
        requestPaymentInfo: boolean;
        additionalItems: AdditionalItem[];
    }>()
);

export const checkoutCompleted = createAction(
    "[Subscription] checkoutCompleted",
    props<{
        authenticateResultModel: AuthenticateResultModel;
    }>()
);

export const gotoOrderBump = createAction("[Subscription] gotoOrderBump");

export const checkoutComplete = createAction(
    "[Subscription] checkoutComplete",
    props<{
        result: CheckoutResponse;
    }>()
);

export const checkoutError = createAction(
    "[Subscription] checkoutError",
    props<{
        error;
    }>()
);

export const setBuyer = createAction("[Subscription] setBuyer", props<{ buyer: Buyer }>());

export const migrationNotSupported = createAction("[Subscription] migrationNotSupported");

export const patientNotAllowed = createAction("[Subscription] patientNotAllowed");

export const orderBumpLoadError = createAction("[Subscription] orderBumpLoadError", props<{ error: any }>());
